/**
 * Where a business transaction-PIN reset request is in its life.
 *
 * `Pending` is the only actionable state: Afriex operations approves or rejects
 * it, and a request nobody acts on before its configured expiry is read as
 * `Expired` rather than staying actionable indefinitely. Approval clears the
 * PIN, which is what makes the next transaction prompt for a new one.
 */
export var BusinessPinResetRequestStatus;
(function (BusinessPinResetRequestStatus) {
    BusinessPinResetRequestStatus["Pending"] = "PENDING";
    BusinessPinResetRequestStatus["Approved"] = "APPROVED";
    BusinessPinResetRequestStatus["Rejected"] = "REJECTED";
    BusinessPinResetRequestStatus["Expired"] = "EXPIRED";
})(BusinessPinResetRequestStatus || (BusinessPinResetRequestStatus = {}));
//# sourceMappingURL=BusinessPinResetRequestStatus.js.map